import React from 'react';

/**
 * Check if player can afford a card.
 * card.cost uses uppercase color keys (WHITE, BLUE, ...).
 * playerState has .tokens (what they hold) and .bonuses (from purchased cards).
 */
export const canBuyCard = (card, playerState) => {
  if (!card?.cost || !playerState) return false;
  let goldNeeded = 0;
  for (const [color, amount] of Object.entries(card.cost)) {
    const bonus = playerState.bonuses?.[color] || 0;
    const needed = Math.max(0, amount - bonus);
    const have = playerState.tokens?.[color] || 0;
    if (have < needed) goldNeeded += needed - have;
  }
  return (playerState.tokens?.['GOLD'] || 0) >= goldNeeded;
};

export const renderCardCost = (cost) => {
  if (!cost) return null;
  return (
    <div className="card-cost">
      {Object.entries(cost).map(([color, count]) => (
        <div key={color} className={`token-icon ${color.toLowerCase()}`} data-count={count} />
      ))}
    </div>
  );
};
